import { createEndpointBuilder, PathWithSlash } from '@/shared/api';

const DASHBOARD_BASE_PATH: PathWithSlash = '/api/v1/dashboard';

export const createDashboardEndpointBuilder = (subPath: PathWithSlash) =>
  createEndpointBuilder(`${DASHBOARD_BASE_PATH}${subPath}`);
